import React, { useState } from "react";
import toast from "react-hot-toast";

import { authApiService } from "../../../../api/api";
import {
  IProductType,
  IProductTypeCreateDto,
} from "../../../../types/productType.type";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import EditInput from "../inputs/EditInput/EditInput";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
  type: IProductType;
}

const EditProductTypeForm: React.FC<Props> = (props) => {
  const [name, setName] = useState<string>(props.type.name);
  const [description, setDescription] = useState<string>(
    props.type.description
  );

  const onClickApply = async () => {
    try {
      const body: IProductTypeCreateDto = {
        name,
        description,
      };

      const response = await authApiService.updateProductType(
        props.type.id,
        body
      );

      if (response) {
        props.onApply();
      }
    } catch (err: any) {
      toast.error(err.message);
      console.error(err);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.form}>
        <EditInput
          value={name}
          setValue={setName}
          isRequired
          title="Тип"
        ></EditInput>
        <EditInput
          value={description}
          setValue={setDescription}
          title="Опис"
          isRequired={false}
          isBig={true}
        />
      </div>
      <ModalBottomButtons
        onPressApply={onClickApply}
        onPressBack={props.onClose}
        isDeleteBackButton={true}
        applyTitle="Зберегти"
        backTitle="Видалити"
      />
    </div>
  );
};

export default EditProductTypeForm;
